// React
import React from 'react';

// Packages

// Utilities
import { useInitiativeDataStore } from 'utilities/store';
import { useLabels, useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';

const Name = CONSTANTS.ACTIVITIES.TEAM_EDUCATION;

const Choice = props => {
    return ActivityChoice({
        Name,
        methods: 'Initiative_Activity__c.Education_Type__c',
        fieldName: 'Education_Type__c',
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                methodsFieldName: 'Education_Type__c',
                tagTypes: [CONSTANTS.TAGS.TEAM_EDUCATION_ACTIVITY],
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    // ///////////////////
    // STORES
    // ///////////////////

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, label } = useLabels();
    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.TEAM_EDUCATION_ACTIVITY],
    });

    // ///////////////////
    // METHODS
    // ///////////////////

    function getItemData(formData) {
        const { Employees, Education_Type__c } = formData;

        // Data for sf
        return {
            Education_Type__c,
            activityEmployees: Employees?.map(item => item.selectValue),
        };
    }

    function addItemCallback(data) {
        const { _activityEmployees } = data;

        utilities.updateInitiativeDataRelations(
            '_activityEmployees',
            _activityEmployees
        );
    }

    function editItemCallback(data) {
        const { Id, _activityEmployees } = data;

        utilities.removeInitiativeDataRelations(
            '_activityEmployees',
            item => item.Initiative_Activity__c === Id
        );

        utilities.updateInitiativeDataRelations(
            '_activityEmployees',
            _activityEmployees
        );
    }

    // ///////////////////
    // FIELDS
    // ///////////////////

    function fields() {
        // Get employees
        const employees = utilities.employeesFunded.getAll();

        return [
            {
                type: 'SelectList',
                name: 'Employees',
                object: object.config('Initiative_Activity__c.Employee__c'),
                listMaxLength: 10,
                options: employees.map(employee => ({
                    value: employee.Id,
                    label: `${employee.Full_Name__c} - ${employee.Job_Title__c}`,
                })),
                missingOptionsLabel: label('EmptyStateInputEmployeesFunded'),
            },
        ];
    }

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        addItemCallback,
        editItemCallback,
        tagging: tagging.activity,
        fields,
        getItemData,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // DETAILS
    // ///////////////////

    const { Education_Type__c } = utilities.activities.get(id);

    // Choice
    form.setValue('Education_Type__c', Education_Type__c);

    // Employees
    form.setValue(
        'Employees',
        utilities.activityEmployees
            .getFromActivityId(id)
            .map(activityEmployee => ({
                selectValue: activityEmployee.Initiative_Employee_Funded__c,
            }))
    );

    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
